<template>
  <div>
    <b-container fluid>

      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col>

              <b-form-group align="left">
                <label>Palabra clave</label>
                <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input name="nombre" placeholder="Nombre de la financiera"
                                v-model="filtro.palabraClave" @keydown.enter.native="obtenerConfiguraciones"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

            </b-col>

            <b-col></b-col>

            <b-col align="right">
              <b-button v-b-tooltip.hover title="Crear configuración" v-if="$localStorageService.can('Conf_01_financia_crear')" variant="outline-success"
                        @click="agregar()"
              >Crear configuración
              </b-button>
            </b-col>

          </b-row>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-table
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos"
              fixed>
            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button
                    title="Modificar configuración"
                    size="sm"
                    variant="outline-warning"
                    @click="modificar(row.item)"
                    v-if="$localStorageService.can('Conf_01_financia_editar')"
                ><em class="fa fa-pencil"></em></b-button>
                <b-button
                    v-if="!row.item.registroActivo && $localStorageService.can('Conf_01_financia_activar')"
                    title="Activar configuración"
                    variant="outline-success"
                    size="sm"
                    @click="activarDesactivar(row.item)"
                ><em class="fa fa-undo"></em></b-button>
                <b-button v-if="row.item.registroActivo && $localStorageService.can('Conf_01_financia_activar')"
                          title="Desactivar configuración"
                          variant="outline-danger"
                          size="sm"
                          @click="activarDesactivar(row.item)"
                >
                  <b-icon icon="trash-fill"></b-icon>
                </b-button>
              </b-button-group>
            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="registrosPorPagina"
                aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>

      <b-modal
          v-model="show"
          :title="tituloModal"
          size="lg"
      >
        <b-container fluid>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group align="left">
                  <label>Financiera
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <v-select id="nombreMenu" name="nombreMenu" placeholder="Selecciona una financiera"
                              v-model="$v.configuracion.idFinanciera.$model"
                              label="financiera"
                              style="width: 95%"
                              :reduce="(variable) => variable.idFinanciera"
                              :options="financieras"
                              :disabled="editar"
                              :state="validateState('idFinanciera')"
                              :class="selectClass('idFinanciera')"

                    >
                    </v-select>
                  </b-input-group>
                </b-form-group>
                <b-form-group align="left">
                  <label>Plazo
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input id="nivel" name="nivel" placeholder="Plazo"
                                 type="number" v-model="$v.configuracion.plazo.$model"
                                  min="1"
                                  oninput="validity.valid||(value='');" onpaste="return false;"
                                  :state="validateState('plazo')"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
                <b-form-group align="left">
                  <label>Mínimo
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input id="nivel" name="nivel" placeholder="Mínimo"
                                  type="number" v-model="$v.configuracion.minimo.$model"
                                  min="0"
                                  @input="soloNumeros($event)"
                                  @keydown="filterJustNumber($event)"
                                  onpaste="return false;"
                                  :state="validateState('minimo')"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
                <b-form-group align="left">
                  <label>Máximo
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input id="nivel" name="nivel" placeholder="Máximo"
                                  min="0"
                                  @input="soloNumeros($event)"
                                  @keydown="filterJustNumber($event)" onpaste="return false;"
                                  type="number" v-model="$v.configuracion.maximo.$model"
                                  :state="validateState('maximo')"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
                <b-form-group align="left">
                  <label>Comisión
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input id="nivel" name="nivel" placeholder="Comisión"
                                  type="number" v-model="$v.configuracion.comision.$model"
                                  min="0" @input="soloNumeros($event)"
                                  @keydown="filterJustNumber($event)"
                                  onpaste="return false;"
                                  :state="validateState('comision')"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
        </b-container>
        <div slot="modal-footer">
          <b-button variant="outline-primary" :disabled="loaderAcciones" @click="guardar()">
            <span v-if="!loaderAcciones">Guardar</span>
            <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
          </b-button>
          <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
export default {
  name: "ConfiguracionFinanciamiento",
  data: () => ({
    filtro: {
      id: null,
      palabraClave: null,
      registroActivo: null
    },
    datosTabla: [],
    fields: [
      { key: "idComisionSpei", label: "ID", sortable: true },
      { key: "financiera", label: "Financiera", sortable: true },
      { key: "plazo", label: "Plazo", sortable: true },
      { key: "minimo", label: "Mínimo", sortable: true },
      { key: "maximo", label: "Máximo", sortable: true },
      { key: "comision", label: "Comisión", sortable: true },
      "Acciones",
    ],
    registrosPorPagina: 10,
    paginaActual: 0,
    loader: false,
    tituloModal: '',
    loaderAcciones: false,
    show: false,
    editar: null,
    configuracion: {
      idComisionSpei: null,
      idFinanciera: null,
      plazo: null,
      minimo: null,
      maximo: null,
      comision: null,
      registro: null,
    },
    financieras: [],
  }),
  validations: {
    configuracion: {
      idFinanciera:{required},
      plazo: {required},
      minimo: {required},
      maximo: {required},
      comision: {required},
    }
  },
  created() {
    this.obtenerConfiguraciones();
    this.obtenerFinancieras();
  },
  methods: {
    obtenerConfiguraciones(){
      this.loader = true;
      this.$http
          .post(this.$api + "catalogos/obtener/comisionSpei", this.filtro)
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.datosTabla = respuesta.data.data;
            }
          })
          .finally(() => {
            this.loader = false;
          });
    },
    agregar() {
      this.editar = false;
      this.configuracion = {
        idComisionSpei: null,
        idFinanciera: null,
        plazo: null,
        minimo: null,
        maximo: null,
        comision: null,
        registro: null,
      };
      this.tituloModal = 'Agregar Configuración';
      this.show = true;
      this.obtenerFinancieras();
    },
    guardar(){
      this.$v.configuracion.$touch();
      if (this.$v.configuracion.$anyError) {
        return;
      }

       if (this.configuracion.minimo > this.configuracion.maximo) {
        this.$swal({
              position: "top",
              showConfirmButton: false,
              timer: 4200,
              toast: true,
              icon: "info",
              title: "El monto mínimo no debe ser mayor al monto máximo"
          });
        return false;
      }

      if (!this.$v.configuracion.$invalid) {
        this.loaderAcciones = true;
        this.$http.post(this.$api + 'catalogos/guardar/configuracion/financiamiento', this.configuracion).then(respuesta => {
              if (respuesta.data.data) {
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "La configuración se registró correctamente",
                });
                this.filtro= {
                  id: null,
                  palabraClave: null,
                  registroActivo: null
                }
                this.obtenerConfiguraciones();
                this.show = false;
              }
            }
        ).catch(error => {
          console.error(error);
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: "La configuración para esa financiera y ese plazo ya existe. Edítala.",
          });
        }).finally(() => {
              this.loaderAcciones = false;
            }
        )
      }

    },
    modificar(item){
      this.editar = true;
      this.configuracion = item;
      this.tituloModal = "Modificar Configuración";
      this.show = true;
    },
    activarDesactivar(item){
      const mensaje = item.registroActivo ? '¿Está seguro de desactivar la configuración?' : '¿Está seguro de activar la configuración?';
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          const parametros = {
            idComisionSpei: item.idComisionSpei
          }
          this.$http.post(this.$api + 'catalogos/desactivarActivar/comision', parametros).then(respuesta => {
                if (respuesta.data.data) {
                  item.registroActivo = !item.registroActivo;
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "La configuración se actualizó correctamente",
                  });
                }
              }
          )
        }
      })
    },
    obtenerFinancieras() {
      this.$http.get(this.$api + 'financiera/obtener/activas').then(
          respuesta => {
            if (respuesta.data.data) {
              this.financieras = respuesta.data.data;
            }

          }
      )
    },
    cerrarModal() {
      this.show = false;
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.configuracion[name];
      return $dirty ? !$error : null;
    },
    selectClass(attribute) {
      let state = this.validateState(attribute)
      if (state) {
        return 'border rounded-lg border-success'
      } else if (state === false) {
        return 'border rounded-lg border-danger'
      } else {
        return ''
      }
    },
    soloNumeros(e){
      e.target.value = e.target.value.replace(/[^0-9]+/g, '');
    },
    filterJustNumber(e){
      const key = e.key;

      if (key === '-')
        return e.preventDefault();

      // OPTIONAL
      // If is 'e' key, stop it
      if (key === 'e')
        return e.preventDefault();
    },
  }
}
</script>

<style scoped>

</style>
